//MutationComponent primarily used for listening after Sf Chat updates

export default function Observe(className, value) {
    // eslint-disable-next-line no-global-assign
    MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    const targetNode = document.body;
    var agentStatus = { 0: {} };

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationsList) => {
        for (let mutation of mutationsList) {
            if (
                mutation.target.className === className &&
                mutation.type === 'childList' &&
                mutation.removedNodes !== null &&
                mutation.removedNodes.length > 0
            ) {
                if (className === 'message' && mutation.addedNodes && mutation.addedNodes.length > 0) {
                    var agentAvailability =
                        mutation.addedNodes[0].data === 'Chat with an expert' ||
                        mutation.addedNodes[0].data === 'Library chat';
                    var statusAreEqual = mutation.addedNodes[0].data === agentStatus[0].data;
                    // Added object assign because agentStatus struggled to be set with values. (this or that issue?)
                    agentStatus = Object.assign({}, mutation.addedNodes);

                    if (agentAvailability || statusAreEqual) updateAndFinish(agentAvailability);
                } else if (className === 'stateBody embeddedServiceSidebarState') {
                    let startChatForm = document.getElementsByClassName('stateBody embeddedServiceSidebarState');
                    startChatForm = startChatForm && startChatForm.length === 1 ? startChatForm[0] : null;
                    updateAndFinish(null, startChatForm);

                    break;
                }
            }
        }
    };

    const updateAndFinish = (agentAvailability, startChatForm = null) => {
        observer.disconnect();
        value(agentAvailability, null, null, startChatForm);
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}
